const isObject = (item: any): boolean => {
  return typeof item === 'object' && !Array.isArray(item) && item !== null;
};

export default isObject;
